import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import axios from "axios";
import ChargeCreateModal from "./Modals/ChargeCreateModal";
import ChargeEditModal from "./Modals/ChargeEditModal";
import ChargeDeleteModal from "./Modals/ChargeDeleteModal";
import { useUserContext } from "../../contexts/UserContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import ChargeStopRecurringModal from "./Modals/ChargeStopRecurringModal";
import ChargeExtendModal from "./Modals/ChargeExtendModal";
import toast, { Toaster } from "react-hot-toast";

export default function Charges() {
  const { getAuthHeaders, hasFeature } = useUserContext();

  const [charges, setCharges] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [filterStart, setFilterStart] = useState("");
  const [filterEnd, setFilterEnd] = useState("");
  const [projects, setProjects] = useState([]);
  const [openExtend, setOpenExtend] = useState(false);
const [openStop, setOpenStop] = useState(false);		
const [filterProject, setFilterProject] = useState("");
const [openDetail, setOpenDetail] = useState(false);
const [detailCharge, setDetailCharge] = useState(null);
const [filterYear, setFilterYear] = useState("all"); // "all" = toutes les années
  // State pour ouvrir/fermer chaque année
const [openYears, setOpenYears] = useState({});


// 🔹 Pagination states
const [oneTimePage, setOneTimePage] = useState(1);
const [recurringPage, setRecurringPage] = useState(1);
const rowsPerPage = 10; // lignes par page




const openDetailModal = (charge) => {
  setDetailCharge(charge);
  setOpenDetail(true);
};
const getRecurringInstances = (charge) => {
  if (!charge.isRecurring) return [];

  // 🔹 Si c’est un modèle parent, récupérer toutes les charges générées par le CRON
  const generated = charges.filter(
    (c) => c.isGenerated && c.parentRecurringId === charge._id
  );

  if (generated.length > 0) {
    return generated
      .map((inst) => ({
        date: new Date(inst.dateDepense),
        montantTTC: inst.montantTTC,
      }))
      .sort((a, b) => a.date - b.date);
  }

  // 🔹 Sinon (aucune génération encore) on peut générer automatiquement jusqu'à aujourd'hui seulement
  const instances = [];
  const start = new Date(charge.recurrence.startDate);
  const end = charge.recurrence.endDate ? new Date(charge.recurrence.endDate) : new Date();
  const today = new Date();

  let current = new Date(start);

  while (current <= end && current <= today) { // 🔹 Ne pas dépasser aujourd'hui
    instances.push({
      date: new Date(current),
      montantTTC: charge.montantTTC,
    });
    current.setMonth(current.getMonth() + 1);
  }

  return instances;
};



  // =========================
  const filteredCharges = useMemo(() => {
    return charges.filter((c) => {
      const d = new Date(c.dateDepense);
      if (filterStart && d < new Date(filterStart)) return false;
      if (filterEnd && d > new Date(filterEnd)) return false;
      if (filterProject && c.projectId?._id !== filterProject) return false;
      return true;
    });
  }, [charges, filterStart, filterEnd, filterProject]);

  // Tableau principal : charges ponctuelles (manuelles) + générées automatiquement par le CRON
const oneTimeCharges = useMemo(
  () => filteredCharges.filter(c => !c.isRecurring || c.isGenerated),
  [filteredCharges]
);

// Tableau récurrent : seulement les modèles récurrents
const recurringCharges = useMemo(
  () => filteredCharges.filter(c => c.isRecurring && !c.isGenerated),
  [filteredCharges]
);


	const openExtendModal = (charge) => {
  setSelectedCharge(charge);
  setOpenExtend(true);
};	

const openStopRecurringModal = (charge) => {
  setSelectedCharge(charge);
  setOpenStop(true);
};


// Total incluant charges ponctuelles et récurrentes
// Total incluant uniquement les charges passées
const totalWithRecurring = useMemo(() => {
  // 1️⃣ Somme des charges ponctuelles/générées
  const oneTimeSum = oneTimeCharges.reduce(
    (sum, c) => sum + Number(c.montantTTC || 0),
    0
  );

  // 2️⃣ Somme des charges récurrentes : uniquement instances passées
  const recurringSum = recurringCharges.reduce((sum, c) => {
    if (!c.isRecurring) return sum;

    const instances = getRecurringInstances(c); // cette fonction ne renvoie que jusqu'à aujourd'hui
    return sum + instances.reduce((s, inst) => s + Number(inst.montantTTC || 0), 0);
  }, 0);

  return oneTimeSum + recurringSum;
}, [oneTimeCharges, recurringCharges, charges]);

 const total = useMemo(
    () =>
      oneTimeCharges.reduce(
        (sum, c) => sum + Number(c.montantTTC || 0),
        0
      ),
    [oneTimeCharges]
  );

// Fonction pour convertir correctement en nombre
// const parseMontant = (value) => {
//   if (value === undefined || value === null) return 0;
//   const num = typeof value === "number" ? value : Number(String(value).replace(/\D/g, ""));
//   return isNaN(num) ? 0 : num;
// };

// // Format FCFA avec espaces correctement
// const formatFCFA = (value) => parseMontant(value).toLocaleString("fr-FR", { minimumFractionDigits: 0 }) + " FCFA";

  useEffect(() => { 
    fetchCharges(); 
  }, []);

  
  // =========================
  // FETCH DATA
  // =========================
  useEffect(() => {
    fetchCharges();
    fetchProjects();
  }, []);

  const fetchCharges = async () => {
    try {
      const res = await axios.get("http://localhost:4000/charges", {
        headers: getAuthHeaders(),
      });
      setCharges(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Erreur chargement charges");
    }
  };

  const fetchProjects = async () => {
    try {
      const res = await axios.get("http://localhost:4000/data/any", {
        headers: getAuthHeaders(),
      });
      setProjects(res.data.projects || []);
    } catch (err) {
      console.error(err);
    }
  };

// 🔹 Fonctions pour découper les données
const paginatedOneTimeCharges = useMemo(() => {
  const start = (oneTimePage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  return oneTimeCharges.slice(start, end);
}, [oneTimeCharges, oneTimePage]);

const paginatedRecurringCharges = useMemo(() => {
  const start = (recurringPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  return recurringCharges.slice(start, end);
}, [recurringCharges, recurringPage]);

// 🔹 Fonctions pour changer de page
const handleOneTimePageChange = (newPage) => {
  if (newPage < 1 || newPage > Math.ceil(oneTimeCharges.length / rowsPerPage)) return;
  setOneTimePage(newPage);
};

const handleRecurringPageChange = (newPage) => {
  if (newPage < 1 || newPage > Math.ceil(recurringCharges.length / rowsPerPage)) return;
  setRecurringPage(newPage);
};





const exportExcel = () => {
   if (!filteredCharges.length) {
    toast.error("Aucune charge à exporter !");
    return;
  }

  const header = [["Rapport Charges"]];
  const body = filteredCharges.map(c => [
    c.description,
    c.categorie,
    Number(c.montantTTC).toLocaleString("fr-FR"),
    c.devise,
    c.modePaiement,
    c.statut,
    new Date(c.dateDepense).toLocaleDateString("fr-FR"),
    c.projectId?.name || "—" // 🔹 Nom du projet ajouté
  ]);

  const worksheet = XLSX.utils.aoa_to_sheet([
    ...header,
    [""],
    ["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"],
    ...body,
    [""],
    ["TOTAL", "", total.toLocaleString("fr-FR"), "", "", "", "", ""],
    ["Fait à Abidjan, le " + new Date().toLocaleDateString("fr-FR")]
  ]);

  worksheet["!cols"] = [
    { wch: 40 }, { wch: 20 }, { wch: 15 }, { wch: 10 },
    { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 30 }
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Charges");
  XLSX.writeFile(workbook, `Charges_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const exportPDF = () => {
   if (!filteredCharges.length) {
    toast.error("Aucune charge à exporter !");
    return;
  }

  const doc = new jsPDF("landscape", "mm", "a4");
  const startY = 30;

  // Total brut directement depuis la DB
  const totalAmount = filteredCharges.reduce((sum, c) => sum + (c.montantTTC || 0), 0);

  // =========================
  // HEADER COLORÉ
  // =========================
  doc.setFillColor(37, 99, 235); // bleu
  doc.rect(0, 0, 297, 22, "F");
  doc.setTextColor(255);
  doc.setFontSize(16);
  doc.text("SCI MAYEDO — Rapport Charges", 14, 14);
  doc.setFontSize(10);
  doc.text(`Date : ${new Date().toLocaleDateString("fr-FR")}`, 250, 14);
  doc.setTextColor(0);

  // =========================
  // TABLE
  // =========================
  autoTable(doc, {
    startY,
    head: [["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"]],
    body: filteredCharges.map(c => [
      c.description || "-",
      c.categorie || "-",
      (c.montantTTC || 0) + " FCFA",
      c.devise || "FCFA",
      c.modePaiement || "-",
      c.statut || "-",
      new Date(c.dateDepense).toLocaleDateString("fr-FR"),
      c.projectId?.name || "—"
    ]),
    foot: [[
      `TOTAL DES CHARGES : ${totalAmount} FCFA`,
      "", "", "", "", "", "", ""
    ]],
    theme: "striped",
    styles: { fontSize: 9, cellPadding: 3, overflow: "visible", whiteSpace: "nowrap", halign: "center", valign: "middle" },
    headStyles: { fillColor: [243,244,246], textColor: 17, fontStyle: "bold", halign: "center" },
    footStyles: { fillColor: [59,130,246], textColor: [255,255,255], fontStyle: "bold", halign: "center" },
    columnStyles: {
      0: { halign: "left", cellWidth: 50 },  // Description
      1: { cellWidth: 30 },                   // Catégorie
      2: { cellWidth: 30, halign: "right" }, // Montant
      3: { cellWidth: 15 },                   // Devise
      4: { cellWidth: 30 },                   // Mode paiement
      5: { cellWidth: 25 },                   // Statut
      6: { cellWidth: 25 },                   // Date
      7: { cellWidth: 35, halign: "left" }   // Projet
    },
    showFoot: "lastRow"
  });

  // =========================
  // FOOTER (date officielle + pagination)
  // =========================
  const pageCount = doc.getNumberOfPages();
  const formattedDate = new Date().toLocaleDateString("fr-FR");

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(120);

    // Ligne gauche : lieu + date
    doc.text(`Fait à Abidjan, le ${formattedDate}`, 14, 200);

    // Ligne centre : confidentialité
    doc.text("SCI MAYEDO • Document confidentiel", 148, 200, { align: "center" });

    // Ligne droite : pagination
    doc.text(`Page ${i}/${pageCount}`, 280, 200, { align: "right" });
  }

  // =========================
  // Sauvegarde PDF
  // =========================
  doc.setFontSize(14);
  doc.setTextColor(0);
  doc.text("Rapport Charges", 14, 25);

  // 🔹 Ligne total supplémentaire sous la table
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text(`TOTAL DES DÉPENSES : ${totalAmount} FCFA`, 14, doc.lastAutoTable.finalY + 10);

  doc.save(`Charges_${new Date().toISOString().slice(0,10)}.pdf`);
};

const exportOneTimeChargesExcel = () => {
  if (!oneTimeCharges.length) {
    toast.error("Aucune charge ponctuelle à exporter !");
    return;
  }

  const header = [["Rapport Charges Ponctuelles"]];
  const body = oneTimeCharges.map(c => [
    c.description,
    c.categorie,
    Number(c.montantTTC).toLocaleString("fr-FR"),
    c.devise || "FCFA",
    c.modePaiement || "-",
    c.statut || "-",
    new Date(c.dateDepense).toLocaleDateString("fr-FR"),
    c.projectId?.name || "—"
  ]);

  const worksheet = XLSX.utils.aoa_to_sheet([
    ...header,
    [""],
    ["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"],
    ...body,
    [""],
    ["TOTAL", "", oneTimeCharges.reduce((sum, c) => sum + Number(c.montantTTC || 0), 0).toLocaleString("fr-FR"), "", "", "", "", ""],
    ["Fait à Abidjan, le " + new Date().toLocaleDateString("fr-FR")]
  ]);

  worksheet["!cols"] = [
    { wch: 50 }, { wch: 25 }, { wch: 20 }, { wch: 10 },
    { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 30 }
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ChargesPonctuelles");
  XLSX.writeFile(workbook, `ChargesPonctuelles_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const exportOneTimeChargesPDF = () => {
  if (!oneTimeCharges.length) {
    toast.error("Aucune charge ponctuelle à exporter !");
    return;
  }

  const doc = new jsPDF("landscape", "mm", "a4");
  const startY = 30;

  const totalAmount = oneTimeCharges.reduce((sum, c) => sum + Number(c.montantTTC || 0), 0);

  // HEADER
  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, 297, 22, "F");
  doc.setTextColor(255);
  doc.setFontSize(16);
  doc.text("SCI MAYEDO — Charges Ponctuelles", 14, 14);
  doc.setFontSize(10);
  doc.text(`Date : ${new Date().toLocaleDateString("fr-FR")}`, 250, 14);
  doc.setTextColor(0);

  // Largeur totale de la page = 297mm - marges ~10mm
  const totalWidth = 297 - 20; // marge gauche/droite 10mm
  const colWidths = {
    0: 65,  // Description
    1: 35,  // Catégorie
    2: 30,  // Montant TTC
    3: 20,  // Devise
    4: 40,  // Mode paiement
    5: 30,  // Statut
    6: 35,  // Date
    7: 42   // Projet
  };

  // TABLE
  autoTable(doc, {
    startY,
    head: [["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"]],
    body: oneTimeCharges.map(c => [
      c.description || "-",
      c.categorie || "-",
      (c.montantTTC || 0) + " FCFA",
      c.devise || "FCFA",
      c.modePaiement || "-",
      c.statut || "-",
      new Date(c.dateDepense).toLocaleDateString("fr-FR"),
      c.projectId?.name || "—"
    ]),
    foot: [[`TOTAL : ${totalAmount.toLocaleString()} FCFA`, "", "", "", "", "", "", ""]],
    theme: "striped",
    styles: { fontSize: 9, cellPadding: 4, overflow: "linebreak", halign: "center", valign: "middle" },
    headStyles: { fillColor: [243,244,246], textColor: 17, fontStyle: "bold", halign: "center" },
    footStyles: { fillColor: [59,130,246], textColor: [255,255,255], fontStyle: "bold", halign: "center" },
    columnStyles: Object.fromEntries(
      Object.entries(colWidths).map(([key, width]) => [key, { cellWidth: width }])
    ),
    showFoot: "lastRow",
    margin: { left: 10, right: 10 }
  });

  // FOOTER
  const pageCount = doc.getNumberOfPages();
  const formattedDate = new Date().toLocaleDateString("fr-FR");

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(120);

    doc.text(`Fait à Abidjan, le ${formattedDate}`, 14, 200);
    doc.text("SCI MAYEDO • Document confidentiel", 148, 200, { align: "center" });
    doc.text(`Page ${i}/${pageCount}`, 280, 200, { align: "right" });
  }

  doc.save(`ChargesPonctuelles_${new Date().toISOString().slice(0,10)}.pdf`);
};

  const handleDownload = async (chargeId, description) => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token;
      if (!token) throw new Error("Utilisateur non connecté");
      const res = await fetch(`http://localhost:4000/charges/${chargeId}/download`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Erreur téléchargement");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${description || "charge"}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const remainingMonths = (endDate) => {
  if (!endDate) return null;

  const now = new Date();
  const end = new Date(endDate);

  const months =
    (end.getFullYear() - now.getFullYear()) * 12 +
    (end.getMonth() - now.getMonth());

  return months >= 0 ? months : 0;
};


const exportChargeExcel = (charge, year = "all") => {
  if (!charge) return;

  const instances = getRecurringInstancesFiltered(charge, year);

  const header = [["Charges mensuelles de : " + charge.description]];
  const body = instances.map(inst => [
    charge.description,
    charge.categorie,
    Number(inst.montantTTC).toLocaleString("fr-FR"),
    charge.devise || "FCFA",
    charge.modePaiement || "-",
    charge.statut || "—",
    inst.date.toLocaleString("fr-FR", { month: "long", year: "numeric" }),
    charge.projectId?.name || "—"
  ]);

  const worksheet = XLSX.utils.aoa_to_sheet([
    ...header,
    [""],
    ["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"],
    ...body,
    [""],
    ["TOTAL", "", instances.reduce((sum, i) => sum + Number(i.montantTTC || 0), 0) , "FCFA", "", "", "", ""],
    ["Fait à Abidjan, le " + new Date().toLocaleDateString("fr-FR")]
  ]);

  // 🔹 Ajuster la largeur des colonnes
  worksheet["!cols"] = [
    { wch: 50 }, // Description
    { wch: 25 }, // Catégorie
    { wch: 20 }, // Montant TTC
    { wch: 10 }, // Devise
    { wch: 20 }, // Mode paiement
    { wch: 15 }, // Statut
    { wch: 25 }, // Date
    { wch: 35 }  // Projet
  ];


  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Charge");
  XLSX.writeFile(workbook, `Charge_${charge.description}_${year}_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const exportChargePDF = (charge, year = "all") => {
  if (!charge) return;

  const instances = getRecurringInstancesFiltered(charge, year);

  const doc = new jsPDF("landscape", "mm", "a4");
  const startY = 30;

  // 🔹 HEADER
  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, 297, 22, "F");
  doc.setTextColor(255);
  doc.setFontSize(16);
  doc.text(`Charges mensuelles — ${charge.description}`, 14, 14);
  if (year !== "all") doc.text(`Année : ${year}`, 14, 22);
  doc.setFontSize(10);
  doc.text(`Date : ${new Date().toLocaleDateString("fr-FR")}`, 250, 14);
  doc.setTextColor(0);

  // 🔹 TABLE
  autoTable(doc, {
    startY,
    head: [["Description","Catégorie","Montant TTC","Devise","Mode paiement","Statut","Date","Projet"]],
    body: instances.map(inst => [
      charge.description || "-",
      charge.categorie || "-",
      (inst.montantTTC || 0) + " FCFA",
      charge.devise || "FCFA",
      charge.modePaiement || "-",
      charge.statut || "—",
      inst.date.toLocaleString("fr-FR", { month: "long", year: "numeric" }),
      charge.projectId?.name || "—"
    ]),
    foot: [[`TOTAL : ${instances.reduce((sum, i) => sum + Number(i.montantTTC || 0), 0)} FCFA`, "", "", "", "", "", "", ""]],
    theme: "striped",
    styles: { fontSize: 9, cellPadding: 4, overflow: "visible", whiteSpace: "nowrap", halign: "center", valign: "middle" },
    headStyles: { fillColor: [243,244,246], textColor: 17, fontStyle: "bold", halign: "center" },
    footStyles: { fillColor: [59,130,246], textColor: [255,255,255], fontStyle: "bold", halign: "center" },
    columnStyles: {
      0: { halign: "left", cellWidth: 55 },
      1: { cellWidth: 30 },
      2: { cellWidth: 25, halign: "right" },
      3: { cellWidth: 15 },
      4: { cellWidth: 25 },
      5: { cellWidth: 20 },
      6: { cellWidth: 25 },
      7: { cellWidth: 40, halign: "left" }
    },
    showFoot: "lastRow"
  });

  // 🔹 FOOTER
  const pageCount = doc.getNumberOfPages();
  const formattedDate = new Date().toLocaleDateString("fr-FR");

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(120);

    doc.text(`Fait à Abidjan, le ${formattedDate}`, 14, 200);
    doc.text("SCI MAYEDO • Document confidentiel", 148, 200, { align: "center" });
    doc.text(`Page ${i}/${pageCount}`, 280, 200, { align: "right" });
  }

  doc.save(`Charge_${charge.description}_${year}_${new Date().toISOString().slice(0,10)}.pdf`);
};

const getRecurringInstancesFiltered = (charge, year = "all") => {
  const instances = getRecurringInstances(charge);
  if (year === "all") return instances;
  return instances.filter(inst => inst.date.getFullYear() === Number(year));
};


  return (
    <>
      <Navbar />

      <div className="charges-page">
        <div className="charges-header">
          <div>
            <h1>Gestion des Charges & Dépenses</h1>
            <p>Suivi et contrôle des dépenses</p>
          </div>
          <button className="btn-main" onClick={() => setOpenCreate(true)}>➕ Nouvelle charge</button>
        </div>

        {/* 🔹 Filtres période */}
        <div className="filters">
          <label>
            Projet :
            <select
              value={filterProject}
              onChange={(e) => setFilterProject(e.target.value)}
              style={{ marginLeft: 6 }}
            >
              <option value="">Tous les projets</option>
              {projects.map(p => (
                <option key={p._id} value={p._id}>
                  {p.name} ({p.type})
                </option>
              ))}
            </select>
          </label>

          <label>Du : <input type="date" value={filterStart} onChange={e => setFilterStart(e.target.value)} /></label>
          <label>Au : <input type="date" value={filterEnd} onChange={e => setFilterEnd(e.target.value)} /></label>

          <button
              className="btn-export"
              style={{ background: "#6b7280" }}
              onClick={() => {
                setFilterStart("");
                setFilterEnd("");
                setFilterProject("");
              }}
            >
              🔄 Réinitialiser
            </button>

          <button onClick={exportOneTimeChargesExcel} className="btn-export excel">📊 Excel</button>
<button onClick={exportOneTimeChargesPDF} className="btn-export pdf">📄 PDF</button>
        </div>

        <div className="stats-grid">
          <div className="stat-card red">
            <span>Total des charges</span>
            <strong>{totalWithRecurring.toLocaleString()} FCFA</strong>
          </div>
        </div>

        <div className="table-wrapper">
          <table className="charges-table">
            <thead>
              <tr>
                <th>Créé par</th>
                <th>Date</th>
                <th>Projet</th>
                <th>Description</th>
                <th>Catégorie</th>
                <th>Montant TTC</th>
                {/* <th>Devise</th> */}
                <th>Mode paiement</th>
                <th>Statut</th>
                <th>PDF</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {oneTimeCharges.length === 0 ? (
                <tr><td colSpan="9" className="empty">Aucune charge</td></tr>
              ) : oneTimeCharges.map(c => (
                <tr key={c._id}>
                  <td>
                      {c.createdBy ? (
                        <div>
                          <strong>📁 {c.createdBy}</strong>

                          <div style={{ fontSize: "11px", color: "#9ca3af",fontWeight: 600}}>
                            Créé le : {new Date(c.createdAt).toLocaleDateString("fr-FR")}
                          </div>

                          {c.updatedBy && (
                            <div style={{ fontSize: "11px", color: "#2563eb", marginTop: 4,fontWeight: 600 }}>
                              Modifié par : {c.updatedBy}<br />
                              le {new Date(c.updatedAt).toLocaleDateString("fr-FR")}
                            </div>
                          )}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                  <td>{new Date(c.dateDepense).toLocaleDateString()}</td>
                  <td>
                    {c.projectId && typeof c.projectId === "object" && c.projectId.name ? (
                      <strong>{c.projectId.name}</strong>
                    ) : (
                      <span style={{ color: "#9ca3af" }}>—</span>
                    )}
                  </td>
                  <td>{c.description || "-"}</td>
                  <td>{c.categorie}</td>
                  <td className="amount">{Number(c.montantTTC).toLocaleString()} F CFA</td>
                  {/* <td>{c.devise}</td> */}
                  <td>{c.modePaiement}</td>
                  <td>{c.statut}</td>
                  <td>{c.preuvePDF ? <button onClick={() => handleDownload(c._id, c.description)}>📄 PDF</button> : "-"}</td>
                  <td className="actions">
                    <span
                      title="Modifier"
                      onClick={() => {
                        setSelectedCharge(c);
                        setOpenEdit(true);
                      }}
                      className="action-icon edit"
                    >
                      <FiEdit2 size={18} />
                    </span>

                    <span
                      title="Supprimer"
                      onClick={() => {
                        setSelectedCharge(c);
                        setOpenDelete(true);
                      }}
                      className="action-icon delete"
                    >
                      <FiTrash2 size={18} />
                    </span>
                    
                  </td>
                      </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination One-Time Charges */}
{oneTimeCharges.length > rowsPerPage && (
  <div style={{ marginTop: 10, textAlign: "center" }}>
    <button onClick={() => handleOneTimePageChange(oneTimePage - 1)} disabled={oneTimePage === 1}>◀</button>
    <span style={{ margin: "0 10px" }}>Page {oneTimePage} / {Math.ceil(oneTimeCharges.length / rowsPerPage)}</span>
    <button onClick={() => handleOneTimePageChange(oneTimePage + 1)} disabled={oneTimePage === Math.ceil(oneTimeCharges.length / rowsPerPage)}>▶</button>
  </div>
)}
        </div>

{recurringCharges.length > 0 && (
  <>
    <h2 style={{ marginTop: "3rem", marginBottom: "1rem" }}>
      🔁 Charges mensuelles / récurrentes
    </h2>

    <div className="table-wrapper">
      <table className="charges-table">
        <thead>
          <tr>
            <th>Crée par</th>
            <th>Projet</th>
            <th>Description</th>
            <th>Catégorie</th>
            <th>Montant</th>
            <th>Période</th>
            <th>Mode paiement</th>
            <th>Statut</th>
              <th>PDF</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {recurringCharges.map(c => {
            const monthsLeft = remainingMonths(c.recurrence?.endDate);

            return (
              <tr key={c._id}>
                {/* Projet */}
               <td>
                  <div style={{ fontWeight: 600, color: "#111827" }}>
                      {/* 📁 {c.projectId?.name || "—"} */}
                        <strong>📁 {c.createdBy}</strong>
                    </div>

                  {c.createdBy ? (
                    <div style={{ marginBottom: 6 }}>
                      {/* <strong style={{ fontSize: "13px" }}>{c.createdBy}</strong> */}

                      <div style={{ fontSize: "11px", color: "#9ca3af" ,fontWeight: 600}}>
                        Créé le : {new Date(c.createdAt).toLocaleDateString("fr-FR")}
                      </div>

                      {c.updatedBy && (
                        <div style={{ fontSize: "11px", color: "#2563eb", marginTop: 2 ,fontWeight: 600}}>
                          Modifié par : {c.updatedBy}<br />
                          le {new Date(c.updatedAt).toLocaleDateString("fr-FR")}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af", marginBottom: 6 }}>—</div>
                  )}

                  
                </td>
                <td>
                   <div style={{ fontWeight: 600, color: "#111827" }}>
                      📁 {c.projectId?.name || "—"}
                        {/* <strong>📁 {c.createdBy}</strong> */}
                    </div>
                </td>

                {/* Description */}
                <td>
                  <strong>{c.description}</strong>
                  <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                    Début :{" "}
                    {new Date(c.recurrence?.startDate).toLocaleDateString("fr-FR")}
                  </div>
                </td>

                {/* Catégorie */}
                <td>{c.categorie}</td>

                {/* Montant */}
                <td className="amount">
                  {Number(c.montantTTC).toLocaleString()} FCFA
                </td>

                {/* Période */}
                <td>
                  {c.recurrence?.endDate ? (
                    <>
                      <div>
                        Jusqu’au{" "}
                        {new Date(c.recurrence.endDate).toLocaleDateString("fr-FR")}
                      </div>

                      {/* ⏱️ Badge mois restants */}
                      {monthsLeft !== null && (
                        <div style={{ marginTop: 6 }}>
                          <span
                            style={{
                              background: "#fef3c7",
                              color: "#92400e",
                              padding: "4px 8px",
                              borderRadius: 6,
                              fontSize: 12,
                              fontWeight: 600
                            }}
                          >
                            ⏱️ se termine dans {monthsLeft} mois
                          </span>
                        </div>
                      )}
                    </>
                  ) : (
                    <span
                      style={{
                        background: "#dcfce7",
                        color: "#166534",
                        padding: "4px 8px",
                        borderRadius: 6,
                        fontSize: 12,
                        fontWeight: 600
                      }}
                    >
                      ♾️ Illimitée
                    </span>
                  )}
                </td>

                {/* Mode de paiement */}
              <td>
                {c.modePaiement || (
                  <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>
                )}
              </td>

                {/* Statut */}
                <td>
                  <span
                    style={{
                      background: "#dbeafe",
                      color: "#1d4ed8",
                      padding: "4px 8px",
                      borderRadius: 6,
                      fontSize: 12,
                      fontWeight: 600
                    }}
                  >
                    Active
                  </span>
                </td>

                {/* 📎 PDF */}
            <td style={{ textAlign: "center" }}>
  {c.preuvePDF ? (
    <button
      onClick={() => handleDownload(c._id, c.description)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 6,
        background: "#f3f4f6",
        color: "#1f2937",
        fontSize: 12,
        fontWeight: 600,
        border: "none",
        cursor: "pointer"
      }}
      title="Télécharger le justificatif PDF"
    >
      📄 PDF
    </button>
  ) : (
    <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>
  )}
</td>

                {/* Actions */}
                <td className="actions">
                  <span
              title="Voir détails"
              className="action-icon view"
              style={{ background: "rgba(59,130,246,.1)", color: "#2563eb" }}
              onClick={() => openDetailModal(c)}
            >
              👁️
  </span>
                  {/* ⏳ Prolonger */}
                  <span
                    title="Prolonger"
                    className="action-icon"
                    style={{
                      background: "rgba(16,185,129,.15)",
                      color: "#059669"
                    }}
                    onClick={() => openExtendModal(c)}
                  >
                    ⏳
                  </span>

                  {/* 🛑 Arrêter */}
                  <span
                    title="Arrêter la récurrence"
                    className="action-icon"
                    style={{
                      background: "rgba(234,179,8,.15)",
                      color: "#a16207"
                    }}
                    onClick={() => openStopRecurringModal(c)}
                  >
                    🛑
                  </span>

                  {/* 🗑️ Supprimer */}
                  <span
                    title="Supprimer la série"
                    className="action-icon delete"
                    onClick={() => {
                      setSelectedCharge(c);
                      setOpenDelete(true);
                    }}
                  >
                    <FiTrash2 size={18} />
                  </span>

                   <span
                      title="Modifier"
                      onClick={() => {
                        setSelectedCharge(c);
                        setOpenEdit(true);
                      }}
                      className="action-icon edit"
                    >
                      <FiEdit2 size={18} />
                    </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>


{/* Pagination Recurring Charges */}
{recurringCharges.length > rowsPerPage && (
  <div style={{ marginTop: 10, textAlign: "center" }}>
    <button onClick={() => handleRecurringPageChange(recurringPage - 1)} disabled={recurringPage === 1}>◀</button>
    <span style={{ margin: "0 10px" }}>Page {recurringPage} / {Math.ceil(recurringCharges.length / rowsPerPage)}</span>
    <button onClick={() => handleRecurringPageChange(recurringPage + 1)} disabled={recurringPage === Math.ceil(recurringCharges.length / rowsPerPage)}>▶</button>
  </div>
)}
    </div>
  </>
)}

        {/* Modals */}
        <ChargeCreateModal open={openCreate} onClose={() => setOpenCreate(false)} onCreated={fetchCharges}/>
        <ChargeEditModal open={openEdit} charge={selectedCharge} onClose={() => setOpenEdit(false)} onUpdated={fetchCharges}/>
        <ChargeDeleteModal open={openDelete && !!selectedCharge} charge={selectedCharge} onClose={() => setOpenDelete(false)} onDeleted={fetchCharges} />

          <ChargeExtendModal
  open={openExtend}
  charge={selectedCharge}
  onClose={() => setOpenExtend(false)}
  onExtended={fetchCharges}
/>

<ChargeStopRecurringModal
  open={openStop}
  charge={selectedCharge}
  onClose={() => setOpenStop(false)}
  onStopped={fetchCharges}
/>

{openDetail && detailCharge && (
  <div className="modal-overlay">
    <div className="modal-card" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <h3>Détails de la charge</h3>
            <div style={{ display: "flex", gap: "10px", marginBottom: "12px", alignItems: "center" }}>
  <button
    className="btn-export excel"
    onClick={() => exportChargeExcel(detailCharge, filterYear)}
  >
    📊 Export Excel
  </button>
  <button
    className="btn-export pdf"
    onClick={() => exportChargePDF(detailCharge, filterYear)}
  >
    📄 Export PDF
  </button>

  {/* Filtrage par année */}
  {detailCharge.isRecurring && (
    <div>
      <label style={{ fontSize: 14, fontWeight: 600 }}>Année :</label>
      <select
        value={filterYear}
        onChange={(e) => setFilterYear(e.target.value)}
        style={{ marginLeft: 6, padding: "4px 8px", borderRadius: 6, border: "1px solid #d1d5db" }}
      >
        <option value="all">Toutes les années</option>
        {getRecurringInstances(detailCharge)
          .map(i => i.date.getFullYear())
          .filter((v, i, a) => a.indexOf(v) === i) // unique
          .sort((a, b) => b - a)
          .map(y => (
            <option key={y} value={y}>{y}</option>
          ))
        }
      </select>
    </div>
  )}
</div>

      <div className="modal-body">
        <p><strong>Projet :</strong> {detailCharge.projectId?.name || "—"}</p>
        <p><strong>Description :</strong> {detailCharge.description}</p>
        <p><strong>Catégorie :</strong> {detailCharge.categorie}</p>
        <p><strong>Montant TTC :</strong> {Number(detailCharge.montantTTC).toLocaleString()} FCFA</p>
        <p>
          <strong>Période :</strong>{" "}
          {new Date(detailCharge.recurrence?.startDate).toLocaleDateString("fr-FR")} 
          {" — "}
          {detailCharge.recurrence?.endDate ? new Date(detailCharge.recurrence.endDate).toLocaleDateString("fr-FR") : "♾️ Illimitée"}
        </p>

        {detailCharge.isRecurring && (
          <>
            <h4 style={{ marginTop: "1.5rem" }}>Charges mensuelles générées</h4>
            {(() => {
              const instances = getRecurringInstances(detailCharge); // tableau [{ date, montantTTC }]
              
              // Grouper par année
              const grouped = instances.reduce((acc, item) => {
                const year = item.date.getFullYear();
                if (!acc[year]) acc[year] = [];
                acc[year].push(item);
                return acc;
              }, {});

            
              const toggleYear = (year) => {
                setOpenYears(prev => ({ ...prev, [year]: !prev[year] }));
              };

              return Object.keys(grouped).sort((a, b) => b - a).map(year => (
                <div key={year} style={{ marginBottom: "10px" }}>
                  <div
                    onClick={() => toggleYear(year)}
                    style={{
                      cursor: "pointer",
                      background: "#eef2ff",
                      color: "#1e40af",
                      fontWeight: "bold",
                      padding: "8px 12px",
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 4
                    }}
                  >
                    <span>Année {year}</span>
                    <span>{openYears[year] ? "▼" : "▶"}</span>
                  </div>

                  {openYears[year] && (
                    <div style={{ border: "1px solid #d1d5db", borderRadius: "6px", overflow: "hidden" }}>
                      {grouped[year].sort((a, b) => a.date - b.date).map((inst, idx) => (
                        <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "8px 12px", borderBottom: "1px solid #d1d5db" }}>
                          <span>{inst.date.toLocaleString("fr-FR", { month: "long", year: "numeric" })}</span>
                          <span style={{ fontWeight: 600 }}>{Number(inst.montantTTC).toLocaleString()} FCFA</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ));
            })()}
          </>
        )}
      </div>

      <div className="modal-actions">
        <button className="btn-secondary" onClick={() => setOpenDetail(false)}>Fermer</button>
      </div>
    </div>
  </div>
)}

      </div>
      <Footer />

      {/* 🔥 CSS XXL SAAS */}
      <style>{`
        .charges-page {
          padding: 2rem;
          min-height: 100vh;
          background: linear-gradient(180deg, #f8fafc, #eef2f7);
        }

        /* HEADER */
        .charges-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
        }

        .charges-header h1 {
          font-size: 32px;
          font-weight: 700;
          margin: 0;
        }

        .charges-header p {
          color: #6b7280;
          margin-top: 6px;
        }

        .btn-main {
          background: linear-gradient(135deg, #16a34a, #22c55e);
          color: white;
          border: none;
          padding: 14px 22px;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 10px 30px rgba(34,197,94,0.35);
          transition: all 0.2s ease;
        }

        .btn-main:hover {
          transform: translateY(-2px);
        }

        /* STATS */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-bottom: 2rem;
        }

        .stat-card {
          background: white;
          padding: 24px;
          border-radius: 18px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.05);
          display: flex;
          flex-direction: column;
        }

        .stat-card span {
          // color: #6b7280;
          font-size: 14px;
        }

        .stat-card strong {
          font-size: 28px;
          margin-top: 8px;
        }

        .stat-card.red strong {
          color: #dc2626;
        }

        /* TABLE */
        .table-wrapper {
          background: white;
          border-radius: 18px;
          padding: 20px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
          overflow-x: auto;
        }

        .charges-table {
          width: 100%;
          border-collapse: collapse;
        }

        .charges-table th {
          text-align: left;
          padding: 14px;
          color: #6b7280;
          font-size: 13px;
          border-bottom: 1px solid #e5e7eb;
        }

        .charges-table td {
          padding: 16px 14px;
          border-bottom: 1px solid #f1f5f9;
          font-size: 14px;
        }

        .charges-table tr:hover {
          background: #f9fafb;
        }

        .libelle {
          font-weight: 600;
        }

        .amount {
          font-weight: 700;
          color: #dc2626;
        }

        .actions {
          display: flex;
          gap: 10px;
        }

        .btn-edit {
          background: #2563eb;
          color: white;
          border: none;
          padding: 8px 14px;
          border-radius: 8px;
          font-size: 13px;
          cursor: pointer;
        }

        .btn-delete {
          background: #dc2626;
          color: white;
          border: none;
          padding: 8px 14px;
          border-radius: 8px;
          font-size: 13px;
          cursor: pointer;
        }

        .empty {
          text-align: center;
          padding: 30px;
          color: #9ca3af;
        }

        @media (max-width: 768px) {
          .charges-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 14px;
          }
        }
          /* ===============================
   OVERLAY
================================ */
.modal-overlay,
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-body {
  max-height: 70vh; /* limite la hauteur à 70% de la fenêtre */
  overflow-y: auto;  /* scroll vertical si dépasse */
  margin-bottom: 16px;
  padding-right: 8px; /* pour que le scroll ne chevauche pas le contenu */
}

/* ===============================
   MODAL CARD
================================ */
.modal,
.modal-card {
  background: #ffffff; /* ✅ fond blanc */
  border-radius: 16px;
  width: 100%;
  max-width: 520px; /* XXL */
  padding: 28px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
  animation: modalFadeIn 0.25s ease-out;
}

/* Glass effect */
.glass {
  border: 1px solid rgba(255, 255, 255, 0.4);
}

/* Danger modal */
.modal.danger {
  border-top: 5px solid #dc2626;
}

/* ===============================
   TITLES
================================ */
.modal h3,
.modal-card h3 {
  margin-bottom: 18px;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

/* ===============================
   FORM
================================ */
.modal-form,
.modal-card form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal input,
.modal-card input {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
}

.modal input:focus,
.modal-card input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

/* ===============================
   ACTIONS
================================ */
.modal-actions,
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

/* ===============================
   BUTTONS
================================ */
button {
  cursor: pointer;
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 14px;
  font-weight: 500;
}

/* Primary */
.btn-primary {
  background: #2563eb;
  color: #fff;
}

.btn-primary:hover {
  background: #1d4ed8;
}

/* Secondary */
.btn-secondary {
  background: #e5e7eb;
  color: #111827;
}

.btn-secondary:hover {
  background: #d1d5db;
}

/* Danger */
.btn-danger {
  background: #dc2626;
  color: #fff;
}

.btn-danger:hover {
  background: #b91c1c;
}

/* ===============================
   TEXT
================================ */
.modal p {
  font-size: 14px;
  color: #374151;
  margin-bottom: 18px;
}

/* ===============================
   ANIMATION
================================ */
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
      .filters { display:flex; gap:1rem; margin-bottom:1rem; flex-wrap:wrap; align-items:center; }
        .btn-export { padding:0.5rem 1rem; border:none; border-radius:6px; color:#fff; cursor:pointer; font-weight:600; }
        .btn-export.excel { background:#16a34a; }
        .btn-export.pdf { background:#dc2626; }
        .btn-export:hover { opacity:0.85; }

        .action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-icon.edit {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.1);
}

.action-icon.edit:hover {
  background: rgba(37, 99, 235, 0.2);
}

.action-icon.delete {
  color: #dc2626;
  background: rgba(220, 38, 38, 0.1);
}

.action-icon.delete:hover {
  background: rgba(220, 38, 38, 0.2);
}
.action-icon.view {
  color: #2563eb;
  background: rgba(59,130,246,.1);
}

.action-icon.view:hover {
  background: rgba(59,130,246,.2);
}
      `}</style>
    </>
  );
}